export const GET_SUB_DATA = 'sub/GET_SUB_DATA';
export const GET_SUB_DATA_SUCCESS = 'sub/GET_SUB_DATA_SUCCESS';
export const GET_SUB_DATA_FAIL = 'sub/GET_SUB_DATA_FAIL';
export const GET_LAST_SUB_DATA = 'sub/GET_LAST_SUB_DATA';
export const GET_LAST_SUB_DATA_SUCCESS = 'sub/GET_LAST_SUB_DATA_SUCCESS';
export const GET_LAST_SUB_DATA_FAIL = 'sub/GET_LAST_SUB_DATA_FAIL';
export const GET_AGG_SUB_DATA = 'sub/GET_AGG_SUB_DATA';
export const GET_AGG_SUB_DATA_SUCCESS = 'sub/GET_AGG_SUB_DATA_SUCCESS';
export const GET_AGG_SUB_DATA_FAIL = 'sub/GET_AGG_SUB_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/sub.js